import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  Box, Paper, TextField, Button, Typography, Container, Alert, CircularProgress
} from '@mui/material';
import apiClient from '../../services/apiClient';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await apiClient.authenticateUser(email, password);
      const roles = user.roles || [];
      const userData = {
        id: user.user_id,
        email: user.email,
        firstName: user.first_name,
        lastName: user.last_name,
        roles
      };
      if (roles.includes('admin')) {
        localStorage.setItem('isAdmin', 'true');
        localStorage.setItem('userRole', 'admin');
        localStorage.setItem('adminUser', JSON.stringify(userData));
        navigate('/admin');
      } else if (roles.includes('teacher')) {
        localStorage.setItem('userRole', 'teacher');
        localStorage.setItem('teacherUser', JSON.stringify(userData));
        navigate('/teacher-portal');
      } else if (roles.includes('student')) {
        localStorage.setItem('userRole', 'student');
        localStorage.setItem('studentUser', JSON.stringify({
          name: `${userData.firstName} ${userData.lastName}`,
          email: userData.email,
          id: userData.id
        }));
        navigate('/student-portal');
      } else if (roles.includes('parent')) {
        localStorage.setItem('userRole', 'parent');
        localStorage.setItem('parentUser', JSON.stringify({
          name: `${userData.firstName} ${userData.lastName}`,
          email: userData.email,
          id: userData.id
        }));
        navigate('/parent-portal');
      } else {
        setError('Access denied. No portal access for your account.');
      }
    } catch (err) {
      setError(err.message || 'Invalid email or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8 }}>
        <Paper sx={{ p: 4 }}>
          <Typography variant="h4" align="center" gutterBottom>
            Portal Login
          </Typography>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <form onSubmit={handleLogin}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              required
              autoComplete="email"
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              margin="normal"
              required
              autoComplete="current-password"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
              startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>
          <Box sx={{ textAlign: 'center', mt: 1 }}>
            <Button component={Link} to="/forgot-password" size="small" sx={{ textTransform: 'none', color: 'text.secondary' }}>
              Forgot your password?
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;
